// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".health-module_db8d .table_aef6 {\n  display: flex;\n  flex: 1;\n  font-size: 0.8125rem;\n  margin-top: 0.625rem;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Observe/HealthModule/index.scss","index.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;EACA,OAAA;EACA,oBAAA;EACA,oBAAA;ACFR","file":"index.scss","sourcesContent":["@import \"@formant/ui/style/common\";\n\n.health-module {\n    .table {\n        display: flex;\n        flex: 1;\n        font-size: 0.8125rem;\n        margin-top: 0.625rem;\n    }\n}\n",".health-module .table {\n  display: flex;\n  flex: 1;\n  font-size: 0.8125rem;\n  margin-top: 0.625rem;\n}"]}]);
// Exports
exports.locals = {
	"health-module": "health-module_db8d",
	"table": "table_aef6"
};
module.exports = exports;
